import { Dispatch, useEffect } from "react";
import { Product, VariantGroup } from "@/types/types";
import { ColourList } from "@/components/__shared__/ColourList/ColourList";
import { type ColourListOption } from "@/components/__shared__/ColourList/ColourList";
import styles from "./GiftWithPurchaseColours.module.scss";

type GiftWithPurchaseColoursProps = {
  product: Product;
  colourOptions: ColourListOption[];
  selectedVariantGroup?: VariantGroup;
  setSelectedVariantGroup: Dispatch<VariantGroup | undefined>;
  isMobile: boolean;
};

const sortColourOptions = (colours: ColourListOption[]) => {
  const colourOptions = [...colours];

  const colourOptionsAvailable = colourOptions.filter(
    (colourOption) => colourOption.showAsAvailable,
  );

  const colourOptionsNotAvailable = colourOptions.filter(
    (colourOption) => !colourOption.showAsAvailable,
  );

  const combinedColourOptions = [
    ...colourOptionsAvailable,
    ...colourOptionsNotAvailable,
  ];

  return combinedColourOptions;
};

export const GiftWithPurchaseColours: React.FC<GiftWithPurchaseColoursProps> = (
  giftWithPurchaseColoursProps: GiftWithPurchaseColoursProps,
) => {
  const {
    product,
    selectedVariantGroup,
    setSelectedVariantGroup,
    colourOptions,
    isMobile,
  } = giftWithPurchaseColoursProps;

  const sortedColourOptions = sortColourOptions(colourOptions);

  useEffect(() => {
    const defaultVariantGroup = product.variantGroups?.filter(
      (variantGroup) => variantGroup.value === sortedColourOptions[0]?.colour,
    )[0];
    setSelectedVariantGroup(defaultVariantGroup);
  }, []);

  const chooseSelectedColour = (colour: string) => {
    const chosenVariantGroup = product.variantGroups?.filter(
      (variantGroup) => variantGroup.value === colour,
    )[0];
    setSelectedVariantGroup(chosenVariantGroup);
  };

  return (
    <div className={styles.coloursContainer}>
      <ColourList
        colourOptions={sortedColourOptions}
        showMore={isMobile ? 2 : 3}
        selectedLabel={selectedVariantGroup?.value}
        onClick={(colour: string) => chooseSelectedColour(colour)}
      />
    </div>
  );
};
